"use client";

import { motion, useReducedMotion } from "framer-motion";
import {
  FaArrowRight,
  FaMagnifyingGlass,
  FaPenToSquare,
  FaShieldHalved,
} from "react-icons/fa6";

const ease = [0.17, 0.85, 0.438, 0.99] as const;

const services = [
  {
    title: "Detailed Accessibility Audit",
    description:
      "Manual testing and expert review based on WCAG 2.1 / 2.2 Level AA.",
    icon: FaMagnifyingGlass,
    color: "bg-blue-50 text-blue-700 dark:bg-blue-950/60 dark:text-blue-300",
  },
  {
    title: "Accessibility Remediation",
    description:
      "We fix accessibility issues across WordPress, Shopify, Laravel, React, and more.",
    icon: FaPenToSquare,
    color: "bg-violet-50 text-violet-700 dark:bg-violet-950/60 dark:text-violet-300",
  },
  {
    title: "Ongoing Monitoring",
    description:
      "Keep your website accessible with regular scans and expert support.",
    icon: FaShieldHalved,
    color: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300",
  },
];

export default function AdaComplianceServices() {
  const reduceMotion = useReducedMotion();
  const reveal = {
    initial: reduceMotion ? false : { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
    transition: { duration: reduceMotion ? 0 : 0.6, ease },
  };

  return (
    <motion.section
      {...reveal}
      className="bg-[#F8F9FD] px-4 py-14 sm:px-6 sm:py-20 lg:px-8 dark:bg-[#0c1222] transition-colors duration-300 border-y border-slate-100 dark:border-slate-800/80"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-3 text-center">
          <p className="font-poppins text-sm font-bold uppercase tracking-widest text-pink-700 dark:text-pink-400">
            Our Accessibility Services
          </p>
          <h2 className="font-poppins text-3xl font-bold text-indigo-950 dark:text-white sm:text-4xl">
            More Than Just a{" "}
            <span className="text-violet-700 dark:text-violet-400">Scan</span>
          </h2>
          <p className="text-base text-slate-600 dark:text-slate-300">
            We do not just find issues; we help you fix them.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map(({ title, description, icon: Icon, color }) => (
            <article
              key={title}
              className="flex flex-col items-start gap-4 rounded-2xl border border-slate-200/80 bg-white p-6 shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl dark:border-slate-800 dark:bg-slate-900 sm:p-7"
            >
              <span
                className={`grid size-12 place-items-center rounded-xl ${color}`}
              >
                <Icon aria-hidden className="text-xl" />
              </span>
              <h3 className="font-poppins text-lg font-bold text-indigo-950 dark:text-white">
                {title}
              </h3>
              <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
                {description}
              </p>
              {/* <a
                href="#ada-url"
                className="mt-auto inline-flex items-center gap-2 font-semibold text-pink-700 hover:text-pink-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600 dark:text-pink-400 dark:hover:text-pink-300"
              >
                Learn more <FaArrowRight aria-hidden />
              </a> */}
            </article>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
